export default __webpack_public_path__ + "static/media/alert.decc0579.svg";